import { render } from "./EditPickupPage.vue?vue&type=template&id=4783d0d6&ts=true"
import script from "./EditPickupPage.vue?vue&type=script&lang=ts"
export * from "./EditPickupPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__